import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="返回顶部"
      className="fixed bottom-8 right-8 z-50 w-11 h-11 rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600 transition-all duration-300 flex items-center justify-center cursor-pointer whitespace-nowrap"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}